import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsSelectServicePointScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.ServicePoint />
    </View>
  );
};

export default PreProposalsSelectServicePointScreen;
